import { useQuery } from "react-query";
import adminApi from "../api/adminApi";

export const useAnalyticsOverview = (days = 30) =>
  useQuery(["analytics-overview", days], () => adminApi.getAnalyticsOverview(days), {
    staleTime: 60000,
  });

export const useBloodDemand = (days = 90) =>
  useQuery(["analytics-blood-demand", days], () => adminApi.getBloodDemand(days), {
    staleTime: 300000,
  });

export const useLocationAnalytics = (days = 90) =>
  useQuery(["analytics-locations", days], () => adminApi.getLocationAnalytics(days), {
    staleTime: 300000,
  });

export const useTimeAnalytics = (days = 90) =>
  useQuery(["analytics-time", days], () => adminApi.getTimeAnalytics(days), {
    staleTime: 300000,
  });

export const useUserActivity = (days = 30) =>
  useQuery(["analytics-user-activity", days], () => adminApi.getUserActivity(days), {
    staleTime: 120000,
  });

export const useBloodDemandPredictions = () =>
  useQuery("predictions-blood-demand", () => adminApi.getBloodDemandPredictions(), {
    staleTime: 3600000,
  });

export const useAreaPredictions = () =>
  useQuery("predictions-areas", () => adminApi.getAreaPredictions(), {
    staleTime: 3600000,
  });

export const usePredictionSummary = () =>
  useQuery("predictions-summary", () => adminApi.getPredictionSummary(), {
    staleTime: 3600000,
  });
